// main.js
import { createApp } from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import vuetify from "./plugins/vuetify"
import { loadFonts } from "./plugins/webfontloader"

import { setupCalendar, Calendar, DatePicker } from "v-calendar"
import "v-calendar/style.css"

import Swal from "@/services/ui/dialog"
import "./styles/tokens.css"

import VueApexCharts from "vue3-apexcharts"
import { TranslationService, i18n } from "@/services/TranslationService"
import { startKeepAlives } from "@/components/general/Commute/commuteServices/keepAliveService"

// Load web fonts first (non-blocking)
loadFonts()

// IIFE so we can await router readiness cleanly
;(async () => {
  const app = createApp(App)

  // Make SweetAlert available via this.$swal
  app.config.globalProperties.$swal = Swal

  app
    .use(setupCalendar, {})
    .component("calendar", Calendar)
    .component("VCalendar", Calendar)
    .component("VDatePicker", DatePicker)
    .use(router)
    .use(store)
    .use(VueApexCharts)
    .use(vuetify)
    .use(i18n)

  // Wait for router to be ready before mounting
  await router.isReady()
  app.mount("#app")

  // Initialize translations after mount
  TranslationService.initialize()

  // Start both keep-alive loops (transport + contact)
  try {
    startKeepAlives()
  } catch (e) {
    console.warn("keep-alives failed to start:", e)
  }

  // ✅ Register service worker — safe here in main.js
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker
      .register("/firebase-messaging-sw.js")
      .then(registration => {
        console.log("✅ Service Worker registered:", registration)
      })
      .catch(err => {
        console.warn("❌ Service Worker registration failed:", err)
      })
  }
})()
